<div *ngIf="loading" class="spinner-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="dialog-container" *ngIf="!loading && releaseNotes">
  <h2 mat-dialog-title align="center">Novidades da Versão</h2>
  <div class="release-date">
    <strong>Data de Lançamento:</strong> {{ releaseNotes.date | date: 'dd/MM/yyyy' }}
  </div>
  <mat-dialog-content class="mat-typography">
    <div *ngIf="releaseNotes.features?.length">
      <h3>Novos Recursos</h3>
      <ul>
        <li *ngFor="let item of releaseNotes.features">{{ item }}</li>
      </ul>
    </div>

    <div *ngIf="releaseNotes.bugFixes?.length" class="section-bugs">
      <h3>Correções de Bugs</h3>
      <ul>
        <li *ngFor="let item of releaseNotes.bugFixes">{{ item }}</li>
      </ul>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" style="display: flex; justify-content: center; width: 100%;">
    <button mat-raised-button color="primary" (click)="confirm()">Entendi</button>
  </mat-dialog-actions>
</div>